import React from 'react';
import Modal from '../../MaterialUIModal';

const SaveAndPublishConfirmationModal = ({ onConfirm, onCancel }) => (
  <Modal
    className="templatemodal save-as-modal"
    title="Save and Publish"
    onClose={onCancel}
    primaryButton={{ label: 'Continue', onClick: onConfirm }}
    secondaryButton={{ label: 'Cancel', onClick: onCancel }}
  >
    <p>
      You are about to save and publish this Saved Row, which will allow it to
      be drag-and-dropped into communications by all NoteRouter customers. You
      may remove it at any time from your Publisher Folder. Continue?
    </p>
  </Modal>
);

export default SaveAndPublishConfirmationModal;
